import { useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";

import { bgLinearGradient } from "@/app/types/ui";

import { HeadingTwo } from "@/components/ui/typography/HeadingTwo";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { Paragraph } from "@/components/ui/typography/Paragraph";

import verifyImg from "@/assets/reset-password/code-send.svg";
import { CodeVerificationInput } from "@/components/reset-password/CodeVerificationInput";
import { validateLogin } from "@/guards/validateLogin";

export const Route = createFileRoute("/login/verify")({
  beforeLoad: () => {
    validateLogin();
  },
  component: ValidateMFAPage,
});

function ValidateMFAPage() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-5 min-h-screen overflow-hidden">
      {/* Image */}
      <div className="grid col-span-2 bg-beige self-center overflow-hidden">
        <img
          src={verifyImg}
          alt={t("code_verification.img_alt")}
          className="w-3/5 h-auto mx-auto mb-4"
        />
        <div className="flex flex-col gap-4 text-center mx-20 2xl:mx-28">
          <HeadingTwo>{t("code_verification.msg_title")}</HeadingTwo>
          <Paragraph>{t("code_verification.msg_text")}</Paragraph>
        </div>
      </div>

      {/* Verify Form */}
      <div
        className={`grid col-span-3 ${bgLinearGradient} border-l-1 border-neutral-500`}
      >
        <div className="flex flex-col my-auto">
          <div className="mx-auto mb-14">
            <MimiatHorizontalLogo />
          </div>
          <div className="mx-24 2xl:min-w-[575px] 2xl:mx-auto">
            <div className="flex flex-col gap-2 mb-4">
              <HeadingOne>{t("login.mfa.title")}</HeadingOne>
              <Paragraph>{t("login.mfa.subtitle")}</Paragraph>
            </div>
            <CodeVerificationInput type="mfa" />
          </div>
        </div>
      </div>
    </div>
  );
}
